import { render, staticRenderFns } from "./MyEditor.vue?vue&type=template&id=5affa5ae&"
import script from "./MyEditor.vue?vue&type=script&lang=js&"
export * from "./MyEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports